import { SprayCan } from 'lucide-react';
import { SimpleCrudPage } from './_SimpleCrudPage';
import { cleaningZones, type CleaningZone } from '../hooks/useArbreapains';

export function CleaningZonesPage() {
  return (
    <SimpleCrudPage<CleaningZone>
      title="Zones de nettoyage"
      itemLabel="zone"
      icon={<SprayCan size={18} />}
      query={cleaningZones.useList()}
      createMut={cleaningZones.useCreate() as never}
      updateMut={cleaningZones.useUpdate() as never}
      deleteMut={cleaningZones.useDelete()}
      fields={[
        { key: 'name', label: 'Nom', required: true, placeholder: 'Vestiaires + toilettes' },
        { key: 'description', label: 'Description', placeholder: 'Précisions sur la zone' },
      ]}
      renderExtra={(z) =>
        z.description ? (
          <p className="text-xs text-stone-500 mt-0.5 line-clamp-2">{z.description}</p>
        ) : null
      }
    />
  );
}
